import { DefaultInput } from './index'

export default {
    user_id: new DefaultInput('User'),
    entity_id: new DefaultInput(),
    department_id: new DefaultInput(),
    approver_group: new DefaultInput(),
    approver_type: new DefaultInput(),
    final_approver: new DefaultInput(),
}
